import React from 'react';
import ProjectList from '../../../components/projects/ProjectList';
import { useAuth } from '../../../context/AuthContext';
import { Navigate } from 'react-router-dom';

export default function ProjectsPage() {
    const { user, toolPermissions } = useAuth();

    const journalTool = toolPermissions.journal;
    const projectPerms = journalTool?.permissions || journalTool;
    const isGlobalAdmin = user?.role === 'admin';
    const hasGlobalProjectRights = isGlobalAdmin || projectPerms?.view_all_projects || projectPerms?.create_projects;


    if (!hasGlobalProjectRights) {
        return <Navigate to="/admin" replace />;
    }

    return (
        <div className="projects-page-wrapper" style={{ height: '100%', overflow: 'auto' }}>
            <ProjectList variant="admin" />
        </div>
    );
}
